module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-lg-db763ca8.svg";